// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || "https://api.pixelmaker.ai",
  TIMEOUT: 30000, // 30 seconds
};

// API Endpoints
export const API_ENDPOINTS = {
  // Webhook routes
  WEBHOOK: {
    CLERK: "/webhook/clerk",
    HEALTH: "/webhook/health",
  },
  // Templates
  TEMPLATES: "/templates",

  // User management
  USER: {
    GET: "/user",
    UPDATE: "/user/update",
    RESET_MONTHLY: "/user/reset-monthly",
  },

  // Asset management
  VIDEOS: {
    LIST: "/assets",
    DELETE: "/assets",
    FAVORITE: "/assets/favorite",
  },

  // Video generation
  GENERATE: {
    CREATE: "/generate/create",
    STATUS: "/generate/status",
  },

  // Video export
  EXPORT: "/export",

  // File upload
  UPLOAD: {
    S3: "/upload/s3",
  },

  // Models
  MODELS: "/models",
};

// Video generation constants
export const VIDEO_CONFIG = {
  ASPECT_RATIOS: ["16:9", "9:16", "1:1"] as const,
  DEFAULT_ASPECT_RATIO: "16:9" as const,
  DEFAULT_DURATION: 8,
  MIN_DURATION: 4,
  MAX_DURATION: 15,
  MAX_PROMPT_LENGTH: 2000,
};

// Polling intervals
export const POLLING = {
  VIDEO_STATUS: 3000, // 3 seconds
  MAX_RETRIES: 1000, // 50 minutes max
};

// Error messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR:
    "Network connection failed. Please check your internet connection.",
  TIMEOUT_ERROR: "Request timed out. Please try again.",
  CREDIT_LIMIT: "You have reached your video generation limit.",
  INVALID_PROMPT: "Please enter a valid prompt for video generation.",
  VIDEO_NOT_FOUND: "Video not found or has been deleted.",
  GENERATION_FAILED: "Video generation failed. Please try again.",
  UNKNOWN_ERROR: "An unexpected error occurred. Please try again.",
};
